<section class="confirm-dialog">

  <div class="dialog-icon" [class.success]="intent === 'success'">
    <span class="icon-circle">
      <mat-icon>priority_high</mat-icon>
    </span>
  </div>

  <h2 class="dialog-title font-500">{{ title }}</h2>

  <p class="dialog-message font-300" *ngIf="description; else defaultMessage" [innerHTML]="description"></p>
  <ng-template #defaultMessage>
    <p class="dialog-message font-300">
      Ao cancelar, a vitrine <strong>{{ itemName }}</strong> será inativada e não poderá ser publicada novamente.
    </p>
  </ng-template>

  <div class="dialog-actions">
    <button class="btn-outline font-600" type="button" (click)="onCancel()">
      {{ cancelText }}
    </button>
    <button class="btn-solid font-600" type="button" (click)="onConfirm()">
      {{ confirmText }}
    </button>
  </div>
</section>
